module.exports = __webpack_public_path__ + "static/Manpreet.302cd55c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Manpreet.jpg
// module id = 1312
// module chunks = 137408898365125